import { FileTextOutlined } from '@ant-design/icons';
import type { Evidence } from '@packages/types';
import { Card, Col, Row, Space, Tag, Typography } from 'antd';

const { Text, Paragraph } = Typography;

interface EvidenceCardProps {
    evidence: Evidence;
    isSelected: boolean;
    onSelect: (evidence: Evidence) => void;
}

export default function EvidenceCard({ evidence, isSelected, onSelect }: EvidenceCardProps) {
    let confidenceColor = 'green';
    if (evidence.confidence < 0.6) confidenceColor = 'red';
    else if (evidence.confidence < 0.8) confidenceColor = 'orange';

    const hasSnippet = Boolean(evidence?.snippet);

    return (
        <Card
            size="small"
            style={{
                marginBottom: 8,
                border: isSelected ? '2px solid #1890ff' : '1px solid #d9d9d9',
                boxShadow: isSelected ? '0 2px 8px rgba(24, 144, 255, 0.2)' : undefined,
                cursor: 'pointer',
            }}
            styles={{ body: { padding: 12 } }}
            onClick={() => onSelect(evidence)}
            hoverable
        >
            <Space
                direction="vertical"
                size={4}
                style={{ width: '100%' }}
            >
                <Row
                    gutter={[8, 4]}
                    align="middle"
                >
                    <Col flex="auto">
                        <Tag
                            color="blue"
                            icon={<FileTextOutlined />}
                            style={{ cursor: 'pointer', fontSize: 11 }}
                        >
                            {evidence.source_file}
                        </Tag>
                    </Col>
                    <Col>
                        <Text
                            type="secondary"
                            style={{ fontSize: 11 }}
                        >
                            {evidence.date}
                        </Text>
                    </Col>
                    <Col>
                        <div className="flex items-center gap-[4px]">
                            {!hasSnippet && <span className="text-[11px] text-[#666]">No Text Match</span>}
                            <Tag
                                color={confidenceColor}
                                style={{ fontSize: 11, margin: 0 }}
                            >
                                {(evidence.confidence * 100).toFixed(0)}%
                            </Tag>
                        </div>
                    </Col>
                </Row>

                <Paragraph
                    style={{
                        marginTop: 4,
                        marginBottom: 0,
                        fontSize: 12,
                        color: '#666',
                    }}
                >
                    {evidence.explanation}
                </Paragraph>
            </Space>
        </Card>
    );
}
